import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isLoggedIn: false,
  user: null,
  userType: null,
  businessSetupCompleted: false,
  isHydrated: false,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state, action) => {
      state.isLoggedIn = true;
      state.user = action.payload;
      state.isHydrated = true;
      state.userType = action.payload?.userType ?? null;
      state.businessSetupCompleted = !!action.payload?.businessSetupCompleted;
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.userType = null;
      state.businessSetupCompleted = false;
      state.isHydrated = true; // Stay hydrated after logout to avoid loading flash
      if (typeof window !== 'undefined') {
        localStorage.removeItem('auth');
        localStorage.removeItem('persist:root');
      }
    },
    resetAuth: (state) => {
      state.isLoggedIn = false;
      state.user = null;
      state.userType = null;
      state.businessSetupCompleted = false;
    },
    setUserType: (state, action) => {
      state.userType = action.payload.userType;
      state.businessSetupCompleted = action.payload.businessSetupCompleted || false;
    },
    updateBusinessSetupStatus: (state, action) => {
      state.businessSetupCompleted = action.payload;
      // A user who has completed business setup is a business user.
      // Sync userType so all routing guards are consistent.
      if (action.payload === true) {
        state.userType = 'business';
        if (state.user) state.user.userType = 'business';
      }
    },
    /**
     * Called after redux-persist PersistGate resolves.
     * Marks auth as hydrated so ProtectedRoute / loading screens unblock.
     * redux-persist already restores isLoggedIn, user, etc. from persist:root,
     * so we only need to flip the hydration flag here.
     */
    markHydrated: (state) => {
      state.isHydrated = true;
    },
  },
});

export const { login, logout, resetAuth, setUserType, updateBusinessSetupStatus, markHydrated } =
  authSlice.actions;
export default authSlice.reducer;
